import { Logger } from "../../utils/Logger/Logger.js";

export const cookiesLogger = new Logger({
    tags: { category: "Cookies" },
    prefixStrings: ["Cookie"],
    prefixStyles: [Logger.StylePresets.ButtonLabel({ background: "#073a4b", color: "#ffffff" })]
});

export const verboseCookiesLogger = cookiesLogger.withTags({ verboseDebug: "SiteCookie" });